// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
function MandatorViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        var def = $.Deferred();
        if (Bao.Utils.String.IsNullOrEmpty(self.Type())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(isComplete);
        return def.promise();
    };
}
Bao.inherit(MandatorViewModel, SearchPaging);
MandatorViewModel.prototype.PrimaryKey = "MandatorId";
MandatorViewModel.prototype.RefreshUrl = "Uadm/Mandator/Get";
MandatorViewModel.prototype.SaveUrl = "Uadm/Mandator/Save";
MandatorViewModel.prototype.DeleteUrl = "Uadm/Mandator/Delete";
MandatorViewModel.prototype.IsInUseUrl = "Uadm/Mandator/IsInUse";
MandatorViewModel.prototype.PermissionForward = "MandatorMoveForwardSearch";
MandatorViewModel.prototype.PermissionBackward = "MandatorMoveBackwardSearch";
MandatorViewModel.prototype.PermissionSave = "MandatorSave";
MandatorViewModel.prototype.PermissionRefresh = "MandatorRefresh";
MandatorViewModel.prototype.PermissionDelete = "MandatorDelete";
export default MandatorViewModel;